import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { get, orderBy, map, filter, isEmpty } from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Cookie from 'js-cookie';
import StrainCard from '../components/StrainCard';
import StateDropdown from '../components/StateDropdown';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { is } from '@babel/types';

export default function StrainFinderSlice(slice) {
  const dispatch = useDispatch();

  const [strains, setStrains] = useState(false);
  const [strainType, setStrainType] = useState(Cookie.get('strain_type') || 'All');
  const [strainState, setStrainState] = useState(Cookie.get('strain_state') || 'All');
  const [featuredStrains, setFeaturedStrains] = useState(false);

  const [justViewed, setJustviewed] = useState(Cookie.get('just_viewed') || '');
  const [states, setStates] = useState([]);

  const loading = useSelector(state => get(state, 'prismic.strains_list.loading'));
  const data = useSelector(state => get(state, 'prismic.strains_list.data', false));

  useEffect(() => {
    dispatch({
      type: 'PRISMIC_LOAD_REPEATABLE',
      key: 'strains',
      reduxKey: 'strains_list',
      useCache: true
    });
  }, [dispatch]);

  useEffect(() => {
    if (!loading && data) {
      const listTags = map(data, 'tags');
      let sortedData = orderBy(data, 'data.name[0].text', 'asc');
      const filterFeatured = filter(sortedData, el => {
        return el.tags.includes('featured');
      });

      const uniqueTags = [...new Set(listTags.flat())].filter(e => e !== 'featured');
      setStrains(sortedData);
      setStates(uniqueTags);
      setFeaturedStrains(filterFeatured);
    }
  }, [data, loading]);

  useEffect(() => {
    const sortedData = orderBy(data, 'data.name[0].text', 'asc');

    const strainTypeAndStateFilter = el => {
      if (strainType === 'All' && strainState === 'All') return true;
      if (strainType === 'New Strain' && strainState === 'All') return el.data.new_strain === true;
      if (strainType === 'All' && strainState !== 'All') return el.tags.includes(strainState);
      if (strainType !== 'All' && strainType !== 'New Strain' && strainState === 'All')
        return el.data.type === strainType;

      return el.data.type === strainType && el.tags.includes(strainState);
    };

    const filteredByTypeAndState = sortedData.filter(strainTypeAndStateFilter);

    setStrains(filteredByTypeAndState);
  }, [data, loading, strainType, strainState]);

  const handleChange = event => {
    setStrainType(event.target.value);
    Cookie.set('strain_type', event.target.value, { expires: 1 });
  };

  const handleStateChange = event => {
    setStrainState(event.target.value);
    Cookie.set('strain_state', event.target.value, { expires: 1 });
  };

  const backgroundStyle = {
    backgroundColor: slice.primary.background_color,
    color: slice.primary.text_color
  };

  const ShowFeaturedStrains = () => {
    if (isEmpty(featuredStrains)) return null;

    return (
      <div className="featured-strains cool-margin">
        <h2 className="headline">Featured Strains</h2>
        <div className="strains-wrapper">
          {featuredStrains.map((strain, i) => (
            <StrainCard
              strainType={strainType}
              key={i}
              strainID={strain.uid}
              strainName={strain.data.name[0].text}
              strainImage={strain.data.image.url}
              justViewed={justViewed}
              cookie={Cookie}
              newStrain={strain.data.new_strain}
            />
          ))}
        </div>
      </div>
    );
  };

  if (!strains) {
    return null;
  }

  if (loading) {
    return (
      <CircularProgress
        style={{
          position: 'absolute',
          color: 'gray',
          top: 'calc(50% - 25px)',
          left: 'calc(50% - 25px)',
          width: '50px',
          height: '50px'
        }}
      />
    );
  }

  return (
    strains && (
      <div>
        <ShowFeaturedStrains />
        <div className="strain-finder-slice cool-margin section-padding" style={backgroundStyle}>
          <div className="wrapper">
            <div className="filters" style={{ width: '100%', maxWidth: '400px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControl style={{ width: '100%' }}>
                    <TextField
                      id="select-strain-type"
                      select
                      name="select-strain"
                      value={strainType}
                      onChange={handleChange}
                      label="Strain Type"
                      variant="outlined"
                      color="primary">
                      <MenuItem value="All">All</MenuItem>
                      <MenuItem value="Sativa">Sativa</MenuItem>
                      <MenuItem value="Hybrid">Hybrid</MenuItem>
                      <MenuItem value="Indica">Indica</MenuItem>
                      <MenuItem value="New Strain">New Strains</MenuItem>
                    </TextField>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <StateDropdown
                    options={states}
                    value={strainState}
                    onChange={handleStateChange}
                  />
                </Grid>
              </Grid>
            </div>
            <div className="strains">
              {strains.map((strain, i) => (
                <StrainCard
                  strainType={strainType}
                  key={i}
                  strainID={strain.uid}
                  strainName={strain.data.name[0].text}
                  strainImage={strain.data.image.url}
                  justViewed={justViewed}
                  cookie={Cookie}
                  newStrain={strain.data.new_strain}
                />
              ))}
              {strains.length === 0 && (
                <h2 className="center-align">
                  Sorry, no strains match your search. Please change your selection above.
                </h2>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
}
